import { createZitadelAuth, ZitadelAuth } from '@zitadel/react';

const authority = process.env.REACT_APP_ZITADEL_AUTHORITY!;
const clientId = process.env.REACT_APP_ZITADEL_CLIENT_ID!;

const scope = [
  'openid',
  'profile',
  'email',
  'offline_access',
  'urn:zitadel:iam:org:projects:roles',
].join(' ');

export const authClient: ZitadelAuth = createZitadelAuth({
  authority,
  client_id: clientId,
  redirect_uri: `${window.location.origin}/login/callback`,
  post_logout_redirect_uri: `${window.location.origin}/login`,
  response_type: 'code',
  scope,
});

export const storageKey = `oidc.user:${authority}:${clientId}`;

export const getAccessToken = async (): Promise<string | null> => {
  try {
    const user = await authClient.userManager.getUser();
    return user && !user.expired ? user.access_token : null;
  } catch (error) {
    console.error('Failed to read access token:', error);
    return null;
  }
};

// Shared so that several requests failing with 401 at once trigger only one silent refresh.
let refreshInFlight: Promise<string | null> | null = null;

export const refreshAccessToken = (): Promise<string | null> => {
  if (!refreshInFlight) {
    refreshInFlight = authClient.userManager
      .signinSilent()
      .then((user) => (user && !user.expired ? user.access_token : null))
      .catch((error) => {
        console.error('Silent token refresh failed:', error);
        return null;
      })
      .finally(() => {
        refreshInFlight = null;
      });
  }
  return refreshInFlight;
};
